import { useState, useEffect } from "react";

/**
 * Barra fija arriba de la pantalla que avisa cuando hay una versión
 * nueva de la app lista, pero esperando a que cierres el formulario
 * actual para no interrumpirte a mitad de un diligenciamiento (ver
 * serviceWorkerRegistration.js, que dispara estos 2 eventos).
 *
 * Móntala una sola vez, arriba del todo en BacSarampionHome.jsx.
 */
export default function BarraActualizacionBac() {
  const [estado, setEstado] = useState(null); // null | "esperando" | "aplicando"

  useEffect(() => {
    const alEsperar = () => setEstado("esperando");
    const alAplicar = () => setEstado("aplicando");
    window.addEventListener("bac-actualizacion-esperando", alEsperar);
    window.addEventListener("bac-actualizacion-aplicando", alAplicar);
    return () => {
      window.removeEventListener("bac-actualizacion-esperando", alEsperar);
      window.removeEventListener("bac-actualizacion-aplicando", alAplicar);
    };
  }, []);

  if (!estado) return null;

  return (
    <div style={{
      position: "sticky", top: 0, zIndex: 1050,
      background: estado === "aplicando" ? "#16342a" : "#b7791f",
      color: "#fff", textAlign: "center",
      padding: "7px 12px", fontSize: 12.5, fontWeight: 700,
      display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
    }}>
      {estado === "aplicando" ? (
        <>🔄 Actualizando la app…</>
      ) : (
        <>🆕 Hay una versión nueva lista — se instala sola apenas cierres el formulario que tienes abierto.</>
      )}
    </div>
  );
}
